import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';

import { TabBarLinkInterface } from '~/component/router-tab-bar/interfaces/tab-link.interface';

export function getRouteTabBarActivities(
  module: string,
  translateService: TranslateService,
  localizeRouterService: LocalizeRouterService
): TabBarLinkInterface[] {
  return ['published', 'unpublished', 'draft'].map((status) => ({
    name: translateService.instant(`organizer.activity.tab_bar.link.${status}`),
    path: localizeRouterService
      .translateRoute(`organizer.${module}.${status}`)
      .toString(),
  }));
}
